import { render, staticRenderFns } from "./Cgdd.vue?vue&type=template&id=60270e0c&scoped=true&"
import script from "./Cgdd.vue?vue&type=script&lang=js&"
export * from "./Cgdd.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=60270e0c&prod&scoped=true&lang=css&"
import style2 from "./Cgdd.vue?vue&type=style&index=2&id=60270e0c&prod&scoped=true&lang=css&"
import style3 from "./Cgdd.vue?vue&type=style&index=3&id=60270e0c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60270e0c",
  null
  
)

export default component.exports